export const webstoredb = [
  {
    title: "Instagram Clone",
    desc: "Are you looking to create a social media platform for your business or community? Look no further than our Instagram clone website, built with the cutting-edge MERN stack.With our Instagram clone, you can offer your users all the features they know and love from the popular social media app, including photo sharing, commenting, liking, and more. Plus, our MERN stack technology ensures that your platform is fast, reliable, and scalable, even as your user base grows.",
    images: [
      "../assets/webstore/instagram1.png",
      "../assets/webstore/instagram2.png",
    ],
    link: "https://github.com/premprakashgupta/preminsta",
  },
  {
    title: "Netflix Clone",
    desc: "Introducing our brand new Netflix clone website, built with the latest technology in web development - ReactJS! With our Netflix clone, you can enjoy all the features and functionality of the world's leading streaming service without leaving the comfort of your own home.Our website is designed to look and feel just like the real Netflix platform, with a sleek and modern interface that is easy to navigate. You can search for your favorite movies and TV shows, browse through personalized recommendations, and even create your own watchlist of must-see content.",
    images: [
      "../assets/webstore/netflix_1.png",
      "../assets/webstore/netflix_2.png",
      "../assets/webstore/netflix_3.png",
      "../assets/webstore/netflix_4.png",
    ],
    link: "https://63199abc38a3cd4a9cf9b9b5--studyflix.netlify.app/",
  },
  {
    title: "WebEditor",
    desc: "OIntroducing our cutting-edge web-based text editor built with the latest web development technologies, including ReactJS. This innovative tool offers the ultimate writing experience, just like using a notepad on your computer, but with added features that make it even better. With our web editor, you can easily create and edit text documents right from your browser, without the need for any special software or downloads. The interface is simple and user-friendly, allowing you to focus on your writing without any distractions. Plus, the editor is fast and responsive, ensuring a smooth and seamless writing.",
    images: [
      "../assets/webstore/webeditor_1.png",
      "../assets/webstore/webeditor_2.png",
      "../assets/webstore/webeditor_3.png",
    ],
    link: "https://webeditor4u.netlify.app/",
  },
  {
    title: "Resume Builder",
    desc: "Welcome to our Resume Builder website, built using the powerful ReactJS technology!Are you tired of struggling to create a professional-looking resume that catches the eye of potential employers? Our Resume Builder website has been designed to make the process quick and easy, while producing stunning results.With our intuitive interface, you can choose from a range of customizable templates to build a personalized resume that perfectly showcases your skills, experience, and achievements. Whether you're a recent graduate, a seasoned professional, or anything in between, we have a template that will suit your needs.",
    images: [
      "../assets/webstore/resume_1.png",
      "../assets/webstore/resume_2.png",
      "../assets/webstore/resume_3.png",
      "../assets/webstore/resume_4.png",
    ],
    link: "https://resume4u.netlify.app/",
  },
  {
    title: "E - Library",
    desc: "Welcome to our innovative e-library website built using the powerful and cutting-edge technology of ReactJS! Our website offers a seamless and user-friendly experience for all your reading needs, with an extensive collection of digital books, academic papers, and research articles available at your fingertips.Our ReactJS-based e-library website is designed to provide you with an immersive and engaging reading experience. Whether you're a student, a researcher, or simply an avid reader, you'll love the intuitive interface and features that our website offers. With a simple click, you can browse our vast collection of books, search for specific titles or authors, and download your favorite reads to enjoy offline",
    images: [
      "../assets/webstore/elibrary_(1).png",
      "../assets/webstore/elibrary_(2).png",
      "../assets/webstore/elibrary_(3).png",
      "../assets/webstore/elibrary_(4).png",
    ],
    link: "#",
  },
  {
    title: "Portfolio",
    desc: "Our Netflix Clone is a web application built using ReactJS and NodeJS. It allows users to create profiles, post photos, and follow other users, just like the original Instagram app.",
    images: [
      "../assets/webstore/portfolio_1.png",
      "../assets/webstore/portfolio_2.png",
      "../assets/webstore/portfolio_3.png",
    ],
    link: "https://premnce04portfolio.netlify.app/",
  },
];

export const appstoredb = [
  {
    title: "E- Library App",
    image: "../assets/appstore/elibrary_thumb.png",
    desc: "Welcome to our innovative e-library App built using the powerful and cutting-edge technology of Flutter! Our App offers a seamless and user-friendly experience for all your reading needs, with an extensive collection of digital books, academic papers, and research articles available at your fingertips.Our Flutter-based e-library website is designed to provide you with an immersive and engaging reading experience. Whether you're a student, a researcher, or simply an avid reader, you'll love the intuitive interface and features that our App offers. With a simple click, you can browse our vast collection of books, search for specific titles or authors, and download your favorite reads to enjoy offline",
    images: [
      { pic: "../assets/appstore/elibrary_(1).jpg", tag: "Library Interface" },
      { pic: "../assets/appstore/elibrary_(2).jpg", tag: "Home Interface" },
      { pic: "../assets/appstore/elibrary_(3).jpg", tag: "Book Interface" },
      { pic: "../assets/appstore/elibrary_(4).jpg", tag: "Drawer Interface" },
    ],
    link: "#",
  },
  {
    title: "Code discussion App",
    image: "../assets/appstore/code_discussion_thumb.jpg",
    desc: "Welcome to our Code Discussion app built using Flutter, designed to be the perfect platform for students to engage in productive discussions about coding, programming, and related topics. Our app is an excellent platform for students to connect with like-minded peers and teachers, learn new skills, and gain knowledge through discussions.We understand that students preparing for JEE and NEET exams may not be able to give test papers on our platform. However, we provide a wide range of resources and information on coding, programming, and computer science that can help students enhance their skills and knowledge. Our app offers a user-friendly interface that is easy to navigate, and our moderators ensure a safe and respectful environment for all users.Our app is perfect for anyone who wants to learn, share, and discuss coding and programming topics. Whether you are a beginner or an experienced coder, our platform provides an excellent opportunity for you to engage in meaningful discussions, exchange ideas, and seek guidance from fellow students and experts.with our app, you can participate in live coding sessions, discuss trending topics, and access a wide range of resources, including video tutorials, articles, and blogs. Our platform also allows you to connect with experienced teachers and mentors who can provide valuable insights and guidance to help you improve your coding skills",
    images: [
      {
        pic: "../assets/appstore/code_discussion_(1).jpg",
        tag: "Test Interface",
      },
      {
        pic: "../assets/appstore/code_discussion_(2).jpg",
        tag: "Tab Interface",
      },
      {
        pic: "../assets/appstore/code_discussion_(3).jpg",
        tag: "Discussion Interface",
      },
      {
        pic: "../assets/appstore/code_discussion_(4).jpg",
        tag: "Reply Interface",
      },
      {
        pic: "../assets/appstore/code_discussion_(5).jpg",
        tag: "Drawer Interface",
      },
      {
        pic: "../assets/appstore/code_discussion_(6).jpg",
        tag: "Paper Interface",
      },
    ],
    link: "#",
  },
  {
    title: "ToDo App",
    image: "../assets/appstore/flutter_thumb.jpg",
    desc: "Welcome to our amazing small todo app built with Flutter! If you're looking for a simple and efficient way to manage your daily tasks and stay organized, then look no further than our app.With our app, you can easily create and manage your to-do lists with just a few taps. You can add new tasks, set due dates, and prioritize your tasks based on their importance. You can also set reminders to ensure that you never forget an important task.",
    images: [
      { pic: "../assets/appstore/todo_(1).jpg", tag: "To-do Interface" },
      { pic: "../assets/appstore/todo_(2).jpg", tag: "To-do Interface" },
    ],
    link: "#",
  },
  {
    title: "E-Commerce App (Rest API)",
    image: "../assets/appstore/flutter_thumb.jpg",
    desc: "Looking for a convenient and easy-to-use e-commerce app to fulfill all your shopping needs? Look no further than our cutting-edge platform, built with the powerful Flutter framework and supported by a robust REST API!With our app, you'll enjoy an intuitive and user-friendly shopping experience that makes browsing, purchasing, and tracking your orders a breeze. Whether you're on the hunt for the latest fashion trends, tech gadgets, home decor, or any other products you can imagine, our app has you covered with a wide range of options from top brands and retailers.Our platform is built with the latest in technology, ensuring that you have a fast and reliable experience every time you use it. Plus, our REST API ensures that you'll always have access to the most up-to-date product information and inventory, so you can make informed purchasing decisions and never miss out on a great deal.So why wait? Download our e-commerce app today and start shopping smarter, faster, and more efficiently than ever before",
    images: [
      { pic: "../assets/appstore/ecommerce_(1).png", tag: "Login Interface" },
      { pic: "../assets/appstore/ecommerce_(2).png", tag: "Home Interface" },
      { pic: "../assets/appstore/ecommerce_(3).png", tag: "Profile Interface" },
      { pic: "../assets/appstore/ecommerce_(4).png", tag: "Product Interface" },
      { pic: "../assets/appstore/ecommerce_(5).png", tag: "Catelog Interface" },
      {
        pic: "../assets/appstore/ecommerce_(6).png",
        tag: "Category Interface",
      },
    ],
    link: "#",
  },
];
